import Nav from "./../Page/Share/Nav/Nav";
const Post5 = () => {
  return (
    <div>
      <div className="container">
        <Nav></Nav>

        <div className="infowork">
          {/* items Title} */}
          <h2>
            Oasis Product Packaging Design
          </h2>
          {/* items?.Description */}
          <p>

          </p>
          {/* img section */}
          <img src="https://i.ibb.co/sVc3npN/1.jpg" alt="" />
          <img src="https://i.ibb.co/9NYRjd1/2.jpg" alt="" />
          <img src="https://i.ibb.co/2SvpTVR/3.jpg" alt="" />
          <img src="https://i.ibb.co/kykt1v1/4.jpg" alt="" />
          <img src="https://i.ibb.co/Z8fhhD3/5.jpg" alt="" />
          <img src="https://i.ibb.co/9tf6r0c/6.jpg" alt="" />
          <img src="https://i.ibb.co/cvxmCtW/7.jpg" alt="" />
          <img src="https://i.ibb.co/LvQ2NjC/8.jpg" alt="" />
          <img src="https://i.ibb.co/3rZ52yc/9.jpg" alt="" />
          <img src="https://i.ibb.co/mvmWXfv/10.jpg" alt="" />
          <img src="https://i.ibb.co/tMbkJk8/11.jpg" alt="" />
          <img src="https://i.ibb.co/R3DSBpw/12.jpg" alt="" />
          <img src="https://i.ibb.co/X4Y8t17/13.jpg" alt="" />
          <p>

          </p>
        </div>
      </div>
    </div>
  );
};

export default Post5;
